module.exports = __webpack_public_path__ + "static/media/1998-Graubner-3.824f468c.jpg";